import React from 'react';
import styled from 'styled-components';
import { strings } from '/imports/strings';
import { useParams } from 'react-router';
import { Org, canListOrgs, modelClass } from '/imports/api/orgs';
import { timezoneOptions } from '/imports/options';
import { LoadingFlex } from '/imports/ui/LoadingFlex';
import { NotPermittedPage } from '/imports/ui/NotPermittedPage';
import { Select } from '/imports/ui/Select';
import { Checkbox } from '/imports/ui/Checkbox';
import { ImageInput } from '/imports/ui/ImageInput';
import { PhoneInput } from '/imports/ui/PhoneInput';
import { Page } from '/imports/ui/Page';
import { PageHeading } from '/imports/ui/PageHeading';
import { PageBody } from '/imports/ui/PageBody';
import { useMethod, useUser } from '/imports/hooks';
import { autoForm, formConfig } from '/imports/ui/AutoForm';
import { AddressInput } from '/imports/ui/AddressInput';
import { Input } from '/imports/ui/Input';

const OrgPageStyled = styled(Page)`
  .hide {
    display: none;
  }
  form {
    padding-bottom: 6rem !important;
  }
  .field-group .wrapper .file-widget-thumb {
    margin-left: 0;
  }
`;

/** Create/edit form page for an organization. */
export const OrgPage = () => {
  const user = useUser();
  const { _id } = useParams<any>();
  const isNew = _id === 'new';
  const [document, documentLoading] = isNew ? [undefined, false] : useMethod(modelClass.getMethod, _id as string);
  const form = formConfig<Org>([
    [{ field: 'active', input: { type: Checkbox } }],
    [{ field: 'name' }],
    [
      { field: 'avatar', label: 'Icon (*aspect 1:1)', input: { type: ImageInput } },
      { field: 'logo', label: `${strings.Logo()} (*full logo)`, input: { type: ImageInput } }
    ],
    [],
    [
      { field: 'phone', input: { type: PhoneInput } },
      { field: 'website' },
    ],
    [
      { field: 'address', label: strings.Address(), input: { type: AddressInput } },
      // { field: 'address2', label: strings.Address2() },
    ],
    [{ field: 'timezone', label: strings.Timezone(), input: { type: Select, props: { options: timezoneOptions() } } }],
    [
      { field: 'billingAccessCode' },
      { field: 'projectChannel', label: 'Project Channel', input: { type: Select, props: { options: [{ value: 'affiliate', label: 'Affiliate' }, { value: 'dealer', label: 'Dealer' }] } } }
    ],
    // [
    //   { field: 'city', label: strings.City(), asterisk: true },
    //   { field: 'state', label: strings.State(), asterisk: true, input: { type: Select, props: { options: [{ value: '', label: '' }, ...stateOptions] } } },
    //   { field: 'zipcode', label: strings.ZipCode(), asterisk: true },
    // ],
    // [{ field: 'logo', input: { type: ImageInput }, label: strings.Logo() }],
    [{ field: 'primaryColor', input: { type: Input, props: { type: 'color' } } }, { field: 'secondaryColor', input: { type: Input, props: { type: 'color' } } }]
  ]);
  const [OrgForm] = autoForm({
    document,
    createMethod: modelClass.createMethod,
    updateMethod: modelClass.updateMethod,
    deleteMethod: modelClass.deleteMethod,
    form,
    defaultUpdate: { _id, active: true, country: 'US', timezone: timezoneOptions()[0].value, projectChannel: 'affiliate' },
    redirect: '/orgs',
  });
  const initialized = user && !documentLoading;
  if (!initialized) return <LoadingFlex />;
  if (!canListOrgs(user)) return <NotPermittedPage />;
  return (
    <OrgPageStyled className={`page${!initialized ? ' initializing' : ''}`}>
      <PageHeading
        left={<h1>{isNew ? `${strings.New()} ${strings.Organization()}` : `${strings.Edit()} ${strings.Organization()}`}</h1>}
      />
      <PageBody>
        {OrgForm}
      </PageBody>
    </OrgPageStyled>
  );
};